var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRoundedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5355 11.4645L11.4645 18.5355M18.5355 18.5355L11.4645 11.4645M22.5 2.5H7.5C4.73858 2.5 2.5 4.73858 2.5 7.5V22.5C2.5 25.2614 4.73858 27.5 7.5 27.5H22.5C25.2614 27.5 27.5 25.2614 27.5 22.5V7.5C27.5 4.73858 25.2614 2.5 22.5 2.5Z",
    stroke: "#0E56AD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundedBox);
export default __webpack_public_path__ + "static/media/close_rounded_box.5506afdf1e06f5da863e9297da9f2aa6.svg";
export { ForwardRef as ReactComponent };